export default __webpack_public_path__ + "static/media/up-down.6745d3ae.svg";